export interface ErpModuleAuthTarget {
  baseUrl: string;
  defaultRoute?: string;
  /** Chemin d'entrée auth hub. Défaut: home. Utiliser '' pour la racine / (évite 404 /home). */
  authEntryPath?: string;
}

export function buildErpModuleAuthUrl(
  module: ErpModuleAuthTarget,
  authQuery: string,
  gotoPath?: string
): string {
  const base = module.baseUrl.replace(/\/$/, '');
  const goto = encodeURIComponent(gotoPath || module.defaultRoute || '/dashboards');
  const entry = module.authEntryPath !== undefined ? module.authEntryPath : 'home';
  const auth = String(authQuery || '').trim();
  const authPart = auth ? `auth=${auth}&` : '';

  if (!entry || entry === '/') {
    return `${base}/?${authPart}goto=${goto}`;
  }

  return `${base}/${String(entry).replace(/^\//, '')}?${authPart}goto=${goto}`;
}
